const DateFormats = {
  long: 'DD.MM.YYYY',
  long_with_time: 'DD.MM.YYYY HH:mm:ss',
  long_with_short_time: 'DD.MM.YYYY, HH:mm',
  long_with_short_time_no_comma: 'DD.MM.YYYY HH:mm',
  long_dash: 'YYYY-MM-DD',
  short: 'dd.MM.yyyy',
  short_with_time: 'dd.MM.yyyy HH:mm',
};

export default DateFormats;
